import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import GoogleMapReact from "google-map-react";
import DirectionsBusIcon from "@material-ui/icons/DirectionsBus";
import BusHeartMarker from "./BusHeartMarker";
import { makeStyles } from "@material-ui/core/styles";
import { deviceTrackingStyles } from "./DeviceTracking.styles";
import * as API_KEYS from "../../constants/apiKeys";

const useStyles = makeStyles(() => ({
  ...deviceTrackingStyles,
}));

export default function BusMapDialog({ open, onClose, latitude, longitude, statusInfo, useHeartMarker = false }) {
  const classes = useStyles();

  if (!latitude || !longitude) {
    return null;
  }

  const center = { lat: latitude, lng: longitude };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogContent style={{ height: "100vh", padding: 0 }}>
        <GoogleMapReact bootstrapURLKeys={{ key: API_KEYS.MAPS_API_KEY }} defaultCenter={center} defaultZoom={16} options={{ mapTypeId: "roadmap" }}>
          <div
            lat={latitude}
            lng={longitude}
            className={classes.trackingWrapper}
            style={{
              transform: "translate(-50%, -50%)",
              width: useHeartMarker ? 64 : 35,
              height: useHeartMarker ? 64 : 35,
              borderRadius: "50%",
              background: useHeartMarker ? "transparent" : "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: useHeartMarker ? "none" : "0 2px 10px rgba(0,0,0,0.35)",
              border: useHeartMarker ? "none" : `3px solid ${statusInfo.iconColor}`,
            }}
          >
            {useHeartMarker ? <BusHeartMarker size={64} /> : <DirectionsBusIcon className={classes[statusInfo.iconClass]} style={{ fontSize: 28 }} />}
          </div>
        </GoogleMapReact>
      </DialogContent>
    </Dialog>
  );
}
